'use strict';

var cov_i0pry6yk8 = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\view\\view.js',
      hash = '461bde151a19104b82db921fbd145162acfe4b50',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\view\\view.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 17
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 30
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 14,
          column: 6
        }
      },
      '3': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 41
        }
      },
      '4': {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 8,
          column: 46
        }
      },
      '5': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '6': {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 28
        }
      },
      '7': {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '8': {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 26
        }
      },
      '9': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      '10': {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 23,
          column: 24
        }
      },
      '11': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 28,
          column: 9
        }
      },
      '12': {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 25
        }
      },
      '13': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 25
        }
      },
      '14': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 47,
          column: 6
        }
      },
      '15': {
        start: {
          line: 32,
          column: 24
        },
        end: {
          line: 32,
          column: 75
        }
      },
      '16': {
        start: {
          line: 33,
          column: 22
        },
        end: {
          line: 41,
          column: 27
        }
      },
      '17': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 46,
          column: 9
        }
      },
      '18': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 25
        }
      },
      '19': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 25
        }
      },
      '20': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      '21': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 52,
          column: 9
        }
      },
      '22': {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 48
        }
      },
      '23': {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 138,
          column: 6
        }
      },
      '24': {
        start: {
          line: 57,
          column: 22
        },
        end: {
          line: 64,
          column: 24
        }
      },
      '25': {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 137,
          column: 19
        }
      },
      '26': {
        start: {
          line: 66,
          column: 27
        },
        end: {
          line: 71,
          column: 9
        }
      },
      '27': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 136,
          column: 11
        }
      },
      '28': {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 135,
          column: 11
        }
      },
      '29': {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 84,
          column: 15
        }
      },
      '30': {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 90,
          column: 15
        }
      },
      '31': {
        start: {
          line: 91,
          column: 12
        },
        end: {
          line: 91,
          column: 40
        }
      },
      '32': {
        start: {
          line: 92,
          column: 29
        },
        end: {
          line: 92,
          column: 87
        }
      },
      '33': {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 90
        }
      },
      '34': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 46
        }
      },
      '35': {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 144,
          column: 8
        }
      },
      '36': {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 25
        }
      },
      '37': {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 189,
          column: 8
        }
      },
      '38': {
        start: {
          line: 146,
          column: 24
        },
        end: {
          line: 154,
          column: 26
        }
      },
      '39': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 187,
          column: 11
        }
      },
      '40': {
        start: {
          line: 156,
          column: 30
        },
        end: {
          line: 163,
          column: 11
        }
      },
      '41': {
        start: {
          line: 164,
          column: 25
        },
        end: {
          line: 167,
          column: 11
        }
      },
      '42': {
        start: {
          line: 168,
          column: 10
        },
        end: {
          line: 184,
          column: 13
        }
      },
      '43': {
        start: {
          line: 169,
          column: 12
        },
        end: {
          line: 183,
          column: 13
        }
      },
      '44': {
        start: {
          line: 170,
          column: 14
        },
        end: {
          line: 174,
          column: 17
        }
      },
      '45': {
        start: {
          line: 175,
          column: 14
        },
        end: {
          line: 175,
          column: 31
        }
      },
      '46': {
        start: {
          line: 177,
          column: 14
        },
        end: {
          line: 181,
          column: 17
        }
      },
      '47': {
        start: {
          line: 182,
          column: 14
        },
        end: {
          line: 182,
          column: 31
        }
      },
      '48': {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 186,
          column: 27
        }
      },
      '49': {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 213,
          column: 6
        }
      },
      '50': {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 207,
          column: 11
        }
      },
      '51': {
        start: {
          line: 208,
          column: 6
        },
        end: {
          line: 212,
          column: 9
        }
      },
      '52': {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 48
        }
      },
      '53': {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 211,
          column: 61
        }
      },
      '54': {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 231,
          column: 6
        }
      },
      '55': {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 225,
          column: 11
        }
      },
      '56': {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 230,
          column: 9
        }
      },
      '57': {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 48
        }
      },
      '58': {
        start: {
          line: 229,
          column: 8
        },
        end: {
          line: 229,
          column: 61
        }
      },
      '59': {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 236,
          column: 8
        }
      },
      '60': {
        start: {
          line: 235,
          column: 8
        },
        end: {
          line: 235,
          column: 25
        }
      },
      '61': {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 273,
          column: 8
        }
      },
      '62': {
        start: {
          line: 238,
          column: 28
        },
        end: {
          line: 238,
          column: 54
        }
      },
      '63': {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 86
        }
      },
      '64': {
        start: {
          line: 280,
          column: 0
        },
        end: {
          line: 288,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 165
          },
          end: {
            line: 277,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 19
          },
          end: {
            line: 5,
            column: 20
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 16,
            column: 24
          },
          end: {
            line: 16,
            column: 25
          }
        },
        loc: {
          start: {
            line: 16,
            column: 38
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 16
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 36
          }
        },
        loc: {
          start: {
            line: 24,
            column: 41
          },
          end: {
            line: 26,
            column: 7
          }
        },
        line: 24
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 10
          }
        },
        loc: {
          start: {
            line: 26,
            column: 15
          },
          end: {
            line: 28,
            column: 7
          }
        },
        line: 26
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 31,
            column: 22
          },
          end: {
            line: 31,
            column: 23
          }
        },
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 31
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 42,
            column: 35
          },
          end: {
            line: 42,
            column: 36
          }
        },
        loc: {
          start: {
            line: 42,
            column: 41
          },
          end: {
            line: 44,
            column: 7
          }
        },
        line: 42
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 10
          }
        },
        loc: {
          start: {
            line: 44,
            column: 15
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 44
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 49,
            column: 21
          }
        },
        loc: {
          start: {
            line: 49,
            column: 41
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 49
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 50,
            column: 55
          },
          end: {
            line: 50,
            column: 56
          }
        },
        loc: {
          start: {
            line: 50,
            column: 66
          },
          end: {
            line: 52,
            column: 7
          }
        },
        line: 50
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 22
          }
        },
        loc: {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 138,
            column: 5
          }
        },
        line: 56
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 65,
            column: 35
          },
          end: {
            line: 65,
            column: 36
          }
        },
        loc: {
          start: {
            line: 65,
            column: 41
          },
          end: {
            line: 137,
            column: 7
          }
        },
        line: 65
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 78,
            column: 16
          },
          end: {
            line: 78,
            column: 17
          }
        },
        loc: {
          start: {
            line: 78,
            column: 26
          },
          end: {
            line: 136,
            column: 9
          }
        },
        line: 78
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 137,
            column: 9
          },
          end: {
            line: 137,
            column: 10
          }
        },
        loc: {
          start: {
            line: 137,
            column: 15
          },
          end: {
            line: 137,
            column: 17
          }
        },
        line: 137
      },
      '14': {
        name: 'GiftController',
        decl: {
          start: {
            line: 140,
            column: 13
          },
          end: {
            line: 140,
            column: 27
          }
        },
        loc: {
          start: {
            line: 140,
            column: 65
          },
          end: {
            line: 190,
            column: 5
          }
        },
        line: 140
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 142,
            column: 27
          },
          end: {
            line: 142,
            column: 28
          }
        },
        loc: {
          start: {
            line: 142,
            column: 39
          },
          end: {
            line: 144,
            column: 7
          }
        },
        line: 142
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 145,
            column: 20
          },
          end: {
            line: 145,
            column: 21
          }
        },
        loc: {
          start: {
            line: 145,
            column: 32
          },
          end: {
            line: 189,
            column: 7
          }
        },
        line: 145
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 155,
            column: 37
          },
          end: {
            line: 155,
            column: 38
          }
        },
        loc: {
          start: {
            line: 155,
            column: 43
          },
          end: {
            line: 185,
            column: 9
          }
        },
        line: 155
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 168,
            column: 57
          },
          end: {
            line: 168,
            column: 58
          }
        },
        loc: {
          start: {
            line: 168,
            column: 67
          },
          end: {
            line: 184,
            column: 11
          }
        },
        line: 168
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 185,
            column: 12
          }
        },
        loc: {
          start: {
            line: 185,
            column: 17
          },
          end: {
            line: 187,
            column: 9
          }
        },
        line: 185
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 192,
            column: 24
          },
          end: {
            line: 192,
            column: 25
          }
        },
        loc: {
          start: {
            line: 192,
            column: 38
          },
          end: {
            line: 213,
            column: 5
          }
        },
        line: 192
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 205,
            column: 14
          },
          end: {
            line: 205,
            column: 15
          }
        },
        loc: {
          start: {
            line: 205,
            column: 20
          },
          end: {
            line: 206,
            column: 9
          }
        },
        line: 205
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 206,
            column: 11
          },
          end: {
            line: 206,
            column: 12
          }
        },
        loc: {
          start: {
            line: 206,
            column: 17
          },
          end: {
            line: 207,
            column: 9
          }
        },
        line: 206
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 208,
            column: 21
          }
        },
        loc: {
          start: {
            line: 208,
            column: 26
          },
          end: {
            line: 210,
            column: 7
          }
        },
        line: 208
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 210,
            column: 9
          },
          end: {
            line: 210,
            column: 10
          }
        },
        loc: {
          start: {
            line: 210,
            column: 28
          },
          end: {
            line: 212,
            column: 7
          }
        },
        line: 210
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 215,
            column: 32
          },
          end: {
            line: 215,
            column: 33
          }
        },
        loc: {
          start: {
            line: 215,
            column: 46
          },
          end: {
            line: 231,
            column: 5
          }
        },
        line: 215
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 223,
            column: 14
          },
          end: {
            line: 223,
            column: 15
          }
        },
        loc: {
          start: {
            line: 223,
            column: 20
          },
          end: {
            line: 224,
            column: 9
          }
        },
        line: 223
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 224,
            column: 11
          },
          end: {
            line: 224,
            column: 12
          }
        },
        loc: {
          start: {
            line: 224,
            column: 17
          },
          end: {
            line: 225,
            column: 9
          }
        },
        line: 224
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 21
          }
        },
        loc: {
          start: {
            line: 226,
            column: 26
          },
          end: {
            line: 228,
            column: 7
          }
        },
        line: 226
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 228,
            column: 9
          },
          end: {
            line: 228,
            column: 10
          }
        },
        loc: {
          start: {
            line: 228,
            column: 28
          },
          end: {
            line: 230,
            column: 7
          }
        },
        line: 228
      },
      '30': {
        name: 'DownloadController',
        decl: {
          start: {
            line: 233,
            column: 13
          },
          end: {
            line: 233,
            column: 31
          }
        },
        loc: {
          start: {
            line: 233,
            column: 51
          },
          end: {
            line: 274,
            column: 5
          }
        },
        line: 233
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 234,
            column: 27
          },
          end: {
            line: 234,
            column: 28
          }
        },
        loc: {
          start: {
            line: 234,
            column: 39
          },
          end: {
            line: 236,
            column: 7
          }
        },
        line: 234
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 237,
            column: 31
          },
          end: {
            line: 237,
            column: 32
          }
        },
        loc: {
          start: {
            line: 237,
            column: 43
          },
          end: {
            line: 273,
            column: 7
          }
        },
        line: 237
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }],
        line: 9
      },
      '1': {
        loc: {
          start: {
            line: 9,
            column: 10
          },
          end: {
            line: 9,
            column: 150
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 9,
            column: 10
          },
          end: {
            line: 9,
            column: 23
          }
        }, {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 9,
            column: 61
          }
        }, {
          start: {
            line: 9,
            column: 66
          },
          end: {
            line: 9,
            column: 92
          }
        }, {
          start: {
            line: 9,
            column: 96
          },
          end: {
            line: 9,
            column: 123
          }
        }, {
          start: {
            line: 9,
            column: 128
          },
          end: {
            line: 9,
            column: 150
          }
        }],
        line: 9
      },
      '2': {
        loc: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 13,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 13,
            column: 7
          }
        }, {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 13,
            column: 7
          }
        }],
        line: 11
      },
      '3': {
        loc: {
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 157
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 30
          }
        }, {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 11,
            column: 68
          }
        }, {
          start: {
            line: 11,
            column: 73
          },
          end: {
            line: 11,
            column: 99
          }
        }, {
          start: {
            line: 11,
            column: 103
          },
          end: {
            line: 11,
            column: 130
          }
        }, {
          start: {
            line: 11,
            column: 135
          },
          end: {
            line: 11,
            column: 157
          }
        }],
        line: 11
      },
      '4': {
        loc: {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        }, {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        }],
        line: 79
      },
      '5': {
        loc: {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }, {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }],
        line: 169
      },
      '6': {
        loc: {
          start: {
            line: 209,
            column: 15
          },
          end: {
            line: 209,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 209,
            column: 15
          },
          end: {
            line: 209,
            column: 29
          }
        }, {
          start: {
            line: 209,
            column: 33
          },
          end: {
            line: 209,
            column: 47
          }
        }],
        line: 209
      },
      '7': {
        loc: {
          start: {
            line: 227,
            column: 15
          },
          end: {
            line: 227,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 227,
            column: 15
          },
          end: {
            line: 227,
            column: 29
          }
        }, {
          start: {
            line: 227,
            column: 33
          },
          end: {
            line: 227,
            column: 47
          }
        }],
        line: 227
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0, 0],
      '2': [0, 0],
      '3': [0, 0, 0, 0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewsController = function ViewsController($scope, apiOpen, $http, $rootScope, $state, myVars, $mdDialog, ngNotify, $location, PageViews, $mdMedia, $window, $filter, $httpParamSerializerJQLike) {
  _classCallCheck(this, ViewsController);

  cov_i0pry6yk8.f[0]++;

  var self = (cov_i0pry6yk8.s[0]++, this);
  cov_i0pry6yk8.s[1]++;
  $scope.checkinfo = myVars;
  cov_i0pry6yk8.s[2]++;
  this.$onInit = function () {
    cov_i0pry6yk8.f[1]++;
    cov_i0pry6yk8.s[3]++;

    self.myScopeObject = self.clipData;

    var viewcount = (cov_i0pry6yk8.s[4]++, PageViews.get('views'));
    cov_i0pry6yk8.s[5]++;
    if ((cov_i0pry6yk8.b[1][0]++, viewcount > 3) && (cov_i0pry6yk8.b[1][1]++, self.myScopeObject.isbuy === false) && ((cov_i0pry6yk8.b[1][2]++, myVars.checkMember === '1') || (cov_i0pry6yk8.b[1][3]++, myVars.checkMember === null)) && (cov_i0pry6yk8.b[1][4]++, myVars.msisdn === null)) {
      cov_i0pry6yk8.b[0][0]++;
      cov_i0pry6yk8.s[6]++;

      $scope.dangkywifi();
    } else {
        cov_i0pry6yk8.b[0][1]++;
        cov_i0pry6yk8.s[7]++;
        if ((cov_i0pry6yk8.b[3][0]++, viewcount > 3) && (cov_i0pry6yk8.b[3][1]++, self.myScopeObject.isbuy === false) && ((cov_i0pry6yk8.b[3][2]++, myVars.checkMember === '1') || (cov_i0pry6yk8.b[3][3]++, myVars.checkMember === null)) && (cov_i0pry6yk8.b[3][4]++, myVars.msisdn !== null)) {
          cov_i0pry6yk8.b[2][0]++;
          cov_i0pry6yk8.s[8]++;

          $scope.dangky3g();
        } else {
          cov_i0pry6yk8.b[2][1]++;
        }
      }
  };

  cov_i0pry6yk8.s[9]++;
  $scope.dangkywifi = function (ev) {
    cov_i0pry6yk8.f[2]++;

    var confirm = (cov_i0pry6yk8.s[10]++, $mdDialog.confirm().title('Bạn có muốn tiếp tục xem thêm clip ?').textContent('Quý khách chưa đăng ký. Soạn DKC gửi 9399 để tiếp tục sử dụng dịch vụ').clickOutsideToClose(false).escapeToClose(false).ok('Quay lại').targetEvent(ev));
    cov_i0pry6yk8.s[11]++;
    $mdDialog.show(confirm).then(function () {
      cov_i0pry6yk8.f[3]++;
      cov_i0pry6yk8.s[12]++;

      $state.go('app');
    }, function () {
      cov_i0pry6yk8.f[4]++;
      cov_i0pry6yk8.s[13]++;

      $mdDialog.show();
    });
  };

  cov_i0pry6yk8.s[14]++;
  $scope.dangky3g = function (ev) {
    cov_i0pry6yk8.f[5]++;

    var packagename = (cov_i0pry6yk8.s[15]++, $filter('package')(self.myScopeObject.categoryidId));
    var confirm = (cov_i0pry6yk8.s[16]++, $mdDialog.confirm().title('').textContent('Quý khách chưa đăng ký dịch vụ, Để tiếp tục xem clip click ĐỒNG Ý để đăng ký ').ariaLabel('Lucky day').targetEvent(ev).clickOutsideToClose(false).escapeToClose(false).ok('ĐỒNG Ý').cancel('QUAY LẠI'));
    cov_i0pry6yk8.s[17]++;
    $mdDialog.show(confirm).then(function () {
      cov_i0pry6yk8.f[6]++;
      cov_i0pry6yk8.s[18]++;

      $scope.dangky(1);
    }, function () {
      cov_i0pry6yk8.f[7]++;
      cov_i0pry6yk8.s[19]++;

      $state.go('app');
    });
  };

  cov_i0pry6yk8.s[20]++;
  $scope.dangky = function (packageid) {
    cov_i0pry6yk8.f[8]++;
    cov_i0pry6yk8.s[21]++;

    $http.post(apiOpen + 'dangky/' + packageid).then(function (results) {
      cov_i0pry6yk8.f[9]++;
      cov_i0pry6yk8.s[22]++;

      $window.location = results.data.message;
    });
  };

  // alert(PageViews.get('views'));
  cov_i0pry6yk8.s[23]++;
  $scope.showBuy = function (ev) {
    cov_i0pry6yk8.f[10]++;

    var confirm = (cov_i0pry6yk8.s[24]++, $mdDialog.confirm().title('Bạn đồng ý mua nội dung này với giá 2000đ?').textContent('Tên clip : ' + self.myScopeObject.title).ariaLabel('Lucky day').targetEvent(ev).clickOutsideToClose(true).ok('Đồng ý !').cancel('Không'));
    cov_i0pry6yk8.s[25]++;
    $mdDialog.show(confirm).then(function () {
      cov_i0pry6yk8.f[11]++;

      var contentBuy = (cov_i0pry6yk8.s[26]++, {
        msisdn: myVars.msisdn,
        clip: $filter('urlEncode')(self.myScopeObject.title),
        link: $location.absUrl(),
        id: self.myScopeObject.id
      });

      cov_i0pry6yk8.s[27]++;
      $http({
        method: 'POST',
        url: apiOpen + 'clips/buy',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: $httpParamSerializerJQLike(contentBuy)
      }).then(function (result) {
        cov_i0pry6yk8.f[12]++;
        cov_i0pry6yk8.s[28]++;

        if (result.data.status !== '0') {
          cov_i0pry6yk8.b[4][0]++;
          cov_i0pry6yk8.s[29]++;

          ngNotify.set('Có lỗi xảy ra , xin vui lòng thử lại sau !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
        } else {
          cov_i0pry6yk8.b[4][1]++;
          cov_i0pry6yk8.s[30]++;

          ngNotify.set('Bạn đã tải clip thành công', {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          cov_i0pry6yk8.s[31]++;
          $scope.showDownloadDialog();
          var filename = (cov_i0pry6yk8.s[32]++, self.myScopeObject.extendlink.replace(/^.*(\\|\/|\:)/, ''));
          cov_i0pry6yk8.s[33]++;
          $window.location = apiOpen + 'clips/getSteamingFile/' + self.myScopeObject.id;
          // return $http.get(apiOpen + 'clips/getSteamingFile/' + self.myScopeObject.id).then(results => {
          //   // return $http.get(apiOpen + 'clips/find/' + $stateParams.clipid).then(results => {
          //   return results.data;
          // });
          // $http({
          //   method: 'GET',
          //   url: apiOpen + 'clips/download/' + self.myScopeObject.id,
          //   responseType: 'arraybuffer'
          // }).then(result => {
          //   const contentType = 'application/octet-stream';
          //
          //   const linkElement = document.createElement('a');
          //   try {
          //     var file = new Blob([result.data], {type: contentType});
          //
          //     var isChrome = !!window.chrome && !!window.chrome.webstore;
          //     var isIE = /*@cc_on!@*/false || !!document.documentMode;
          //     var isEdge = !isIE && !!window.StyleMedia;
          //
          //
          //     if (isChrome){
          //       var url = window.URL || window.webkitURL;
          //
          //       var downloadLink = angular.element('<a></a>');
          //       downloadLink.attr('href',url.createObjectURL(file));
          //       downloadLink.attr('target','_self');
          //       downloadLink.attr('download', filename);
          //       downloadLink[0].click();
          //     }
          //     else if(isEdge || isIE){
          //       window.navigator.msSaveOrOpenBlob(file,filename);
          //
          //     }
          //     else {
          //       var fileURL = URL.createObjectURL(file);
          //       window.open(fileURL);
          //     }
          //   } catch (ex) {
          //     console.log(ex);
          //   }
          // });
        }
      });
    }, function () {
      cov_i0pry6yk8.f[13]++;
    });
  };

  function GiftController($scope, $mdDialog, msisdn, receiver) {
    cov_i0pry6yk8.f[14]++;
    cov_i0pry6yk8.s[34]++;

    $scope.title = self.myScopeObject.title;
    cov_i0pry6yk8.s[35]++;
    $scope.closeDialog = function () {
      cov_i0pry6yk8.f[15]++;
      cov_i0pry6yk8.s[36]++;

      $mdDialog.hide();
    };
    cov_i0pry6yk8.s[37]++;
    $scope.gift = function () {
      cov_i0pry6yk8.f[16]++;

      var confirm = (cov_i0pry6yk8.s[38]++, $mdDialog.confirm().title('').textContent('Bạn đồng ý tặng nội dung này cho thuê bao ' + $scope.receiver + ' với giá 2000đ').ariaLabel('Lucky day').targetEvent(this).clickOutsideToClose(false).escapeToClose(false).ok('CÓ').cancel('KHÔNG'));
      cov_i0pry6yk8.s[39]++;
      $mdDialog.show(confirm).then(function () {
        cov_i0pry6yk8.f[17]++;

        var contentGift = (cov_i0pry6yk8.s[40]++, {
          msisdn: myVars.msisdn,
          receiver: $scope.receiver,
          clip: $filter('urlEncode')(self.myScopeObject.title),
          id: self.myScopeObject.id,
          link: $location.absUrl(),
          status: true
        });
        var config = (cov_i0pry6yk8.s[41]++, {
          params: contentGift,
          headers: { Accept: 'application/json' }
        });
        cov_i0pry6yk8.s[42]++;
        $http.get(apiOpen + 'clips/gift', config).then(function (result) {
          cov_i0pry6yk8.f[18]++;
          cov_i0pry6yk8.s[43]++;

          if (result.data.status !== '0') {
            cov_i0pry6yk8.b[5][0]++;
            cov_i0pry6yk8.s[44]++;

            ngNotify.set('Có lỗi xảy ra , xin vui lòng thử lại sau !', {
              position: 'top',
              type: 'error',
              duration: 3000
            });
            cov_i0pry6yk8.s[45]++;
            $mdDialog.hide();
          } else {
            cov_i0pry6yk8.b[5][1]++;
            cov_i0pry6yk8.s[46]++;

            ngNotify.set('Bạn đã tặng clip thành công', {
              position: 'top',
              type: 'success',
              duration: 3000
            });
            cov_i0pry6yk8.s[47]++;
            $mdDialog.hide();
          }
        });
      }, function () {
        cov_i0pry6yk8.f[19]++;
        cov_i0pry6yk8.s[48]++;

        $state.go('app');
      });
    };
  }

  cov_i0pry6yk8.s[49]++;
  $scope.showPrompt = function (ev) {
    cov_i0pry6yk8.f[20]++;
    cov_i0pry6yk8.s[50]++;

    $mdDialog.show({
      controller: GiftController,
      templateUrl: 'app/view/prompt.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: true,
      locals: {
        clipData: self.myScopeObject.clipData,
        msisdn: $scope.msisdn,
        receiver: $scope.receiver
      }
    }).then(function () {
      cov_i0pry6yk8.f[21]++;
    }, function () {
      cov_i0pry6yk8.f[22]++;
    });
    cov_i0pry6yk8.s[51]++;
    $scope.$watch(function () {
      cov_i0pry6yk8.f[23]++;
      cov_i0pry6yk8.s[52]++;

      return (cov_i0pry6yk8.b[6][0]++, $mdMedia('xs')) || (cov_i0pry6yk8.b[6][1]++, $mdMedia('sm'));
    }, function (wantsFullScreen) {
      cov_i0pry6yk8.f[24]++;
      cov_i0pry6yk8.s[53]++;

      $scope.customFullscreen = wantsFullScreen === true;
    });
  };

  cov_i0pry6yk8.s[54]++;
  $scope.showDownloadDialog = function (ev) {
    cov_i0pry6yk8.f[25]++;
    cov_i0pry6yk8.s[55]++;

    $mdDialog.show({
      controller: DownloadController,
      templateUrl: 'app/view/download.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: true
    }).then(function () {
      cov_i0pry6yk8.f[26]++;
    }, function () {
      cov_i0pry6yk8.f[27]++;
    });
    cov_i0pry6yk8.s[56]++;
    $scope.$watch(function () {
      cov_i0pry6yk8.f[28]++;
      cov_i0pry6yk8.s[57]++;

      return (cov_i0pry6yk8.b[7][0]++, $mdMedia('xs')) || (cov_i0pry6yk8.b[7][1]++, $mdMedia('sm'));
    }, function (wantsFullScreen) {
      cov_i0pry6yk8.f[29]++;
      cov_i0pry6yk8.s[58]++;

      $scope.customFullscreen = wantsFullScreen === true;
    });
  };

  function DownloadController($scope, $mdDialog) {
    cov_i0pry6yk8.f[30]++;
    cov_i0pry6yk8.s[59]++;

    $scope.closeDialog = function () {
      cov_i0pry6yk8.f[31]++;
      cov_i0pry6yk8.s[60]++;

      $mdDialog.hide();
    };
    cov_i0pry6yk8.s[61]++;
    $scope.downloadInvoice = function () {
      cov_i0pry6yk8.f[32]++;

      var contentType = (cov_i0pry6yk8.s[62]++, 'application/octet-stream');
      cov_i0pry6yk8.s[63]++;
      $window.location = apiOpen + 'clips/getSteamingFile/' + self.myScopeObject.id;

      // $http({
      //   method: 'GET',
      //   url: apiOpen + 'clips/download/' + self.myScopeObject.id,
      //   responseType: 'arraybuffer'
      // })
      //   .then(function (result) {
      //     var file = new Blob([result.data], {type: contentType});
      //     const filename = self.myScopeObject.extendlink.replace(/^.*(\\|\/|\:)/, '');
      //     var isChrome = !!window.chrome && !!window.chrome.webstore;
      //     var isIE = /*@cc_on!@*/false || !!document.documentMode;
      //     var isEdge = !isIE && !!window.StyleMedia;
      //
      //
      //     if (isChrome){
      //       var url = window.URL || window.webkitURL;
      //
      //       var downloadLink = angular.element('<a></a>');
      //       downloadLink.attr('href',url.createObjectURL(file));
      //       downloadLink.attr('target','_self');
      //       downloadLink.attr('download', filename);
      //       downloadLink[0].click();
      //     }
      //     else if(isEdge || isIE){
      //       window.navigator.msSaveOrOpenBlob(file,filename);
      //
      //     }
      //     else {
      //       var fileURL = URL.createObjectURL(file);
      //       window.open(fileURL);
      //     }
      //     $mdDialog.hide();
      //   })
    };
  }
};

cov_i0pry6yk8.s[64]++;


angular.module('app').component('views', {
  templateUrl: 'app/view/view.html',
  bindings: {
    clipData: '<'
  },
  controller: ViewsController
});